var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-button"},[_c('div',{staticClass:"input-button__button touch",on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.language.code === 'en' ? 'Reset Filter' : 'إعادة الفرز'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }